import React, {useEffect, useState} from 'react'
import {AUDIENCE} from '../../../../../utils/constants'
import {Grid, Typography, Stack} from '@mui/material'
import questionResponseTemplate from '../../../../../utils/questionResponseTemplate'
import QuestionCategory from '../../../../../utils/questionCategory'
import TextField from '@mui/material/TextField'
import QuestionCategoryBadge from '../QuestionCategoryBadge'

export default function TextQuestionRender({
  question,
  audience,
  updateAnswers,
  language = 'en',
}) {
  const [response, setResponse] = useState({
    ...questionResponseTemplate,
    questionId: question.id,
    hasNumValue: question.hasCustomValue,
    participantTypeText:
      audience === AUDIENCE.STAFF
        ? 'Staff'
        : audience === AUDIENCE.PARENT
          ? 'Parent'
          : 'Pupil',
    questionTypeText: 'Open Response',
  })
  return (
    <Grid container>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Stack direction="column" alignItems="center" spacing={1.5}>
          {/* <QuestionCategoryBadge categoryName={question.categoryName} /> */}
          <Typography variant="h1">
            {AUDIENCE.STAFF === audience
              ? question.staffText
              : AUDIENCE.PARENT == audience
                ? question.parentText
                : question.pupilText}
          </Typography>
        </Stack>
      </Grid>
      {question.hasDescription && (
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Typography variant="body1" mb={2} className='ques-desc'>
            {AUDIENCE.STAFF === audience
              ? question.staffDescription
              : AUDIENCE.PARENT == audience
                ? question.parentDescription
                : question.pupilDescription}
          </Typography>
        </Grid>
      )}
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <div className="question-type-answer">
          <TextField
            label={'Enter your response here'}
            multiline
            rows={4}
            fullWidth
            value={response.comment}
            onChange={e => {
              if (
                question.openResponseAttributes.hasCharacterLimit &&
                e.target.value.length >
                  question.openResponseAttributes.maxCharacterLimit
              ) {
                return
              }
              let resp = {...response, comment: e.target.value}
              if (language === 'en') {
                resp['staffQuestion'] = question.staffText
                resp['parentQuestion'] = question.parentText
                resp['studentQuestion'] = question.pupilText
              } else {
                resp['staffQuestion'] = question.staffTextEnglish
                resp['parentQuestion'] = question.parentTextEnglish
                resp['studentQuestion'] = question.pupilTextEnglish
              }

              if (question.categoryId) {
                let category = QuestionCategory.getQuestionCategoryFromId(
                  question.categoryId
                )
                resp.categoryId = question.categoryId
                resp.categoryName = category ? category.name : null
              }

              setResponse({...resp})
              if (updateAnswers) {
                updateAnswers({...resp})
              }
            }}
          />
        </div>
      </Grid>
    </Grid>
  )
}
